<template>
  <div>
    <el-select class="filter__input" size="mini" v-model="value" filterable placeholder="请选择" @change="$emit('input', $event)">
      <el-option :label="item.label" :value="item.value" v-for="(item, index) in lists" :key="index"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number], // 必须为字符串
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    needFilter: {
      type: Boolean, // 必须为字符串
      required: false, // 必须传递该属性
      default: false // 未传值时的默认值
    }
  },
  data () {
    return {
      lists: [
        {
          label: '未审核',
          value: 0
        },
        {
          label: '审核通过',
          value: 1
        },
        {
          label: '需要人工校验',
          value: 2
        },
        {
          label: 'AI识别失败',
          value: 3
        }
      ]
    }
  },
  methods: {
  },
  mounted () {
    if (this.needFilter) {
      this.lists.unshift({
        label: '所有',
        value: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/aiReviewUploadSelect.vue